export default __webpack_public_path__ + "static/media/_united-nations.a20134fc.ico";